import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

Vue.use(Vuex)

const baseUrlElement = document.getElementById('config_url')
const baseURL = baseUrlElement
  ? baseUrlElement.getAttribute('data-base-url')
  : process.env.VUE_APP_BASE_URL;

/*
// Liste blanche des domaines autorisés
const allowedDomains = ['ina.fr', 'skopus.fr']
if (!allowedDomains.some(domain => baseURL.includes(domain))) {
  throw new Error("URL non autorisée");
}
*/

export const store = new Vuex.Store({
  state: {
    recurcive: (state, payload, newChops) => {
      return newChops
    },
    baseUrl: baseURL,
    baseUrlSrc: baseURL === process.env.VUE_APP_BASE_URL
      ? process.env.VUE_APP_BASE_URL
      : baseURL + process.env.VUE_APP_BASE_URL,
    idCritereCounter: 1,
    idDispatchIDCounter: 10000,
    critereToggle: false,
    resetForm: false,
    mediaSelectArray: ['Tous'],
    lastMediaSelect: 'init',
    mediaOpsisValue: {},
    criteres: [],
    sendrequetes: [],
    requetes: []
  },
  getters: {
    getCriteresList: state => {
      // console.log('#AKIDEBUG : state.criteres = ', state.criteres)
      return state.criteres
    },
    getMediaSelectList: state => {
      // console.log('#AKIDEBUG : state.getMediaSelectList = ', state.getMediaSelectList)
      return Object.keys(state.mediaOpsisValue)
    },
    getMediaSelectArrayActive: state => {
      return state.mediaSelectArray
    },
    getCritereToggle: state => {
      // console.log('#AKIDEBUG : state.critereToggle = ', state.critereToggle)
      return state.critereToggle
    },
    getRequeteList: state => {
      // console.log('#AKIDEBUG : state.requetes = ', state.requetes)
      return state.requetes
    },
    getSendRequete: state => {
      // console.log('#AKIDEBUG : state.sendrequetes = ', state.sendrequetes)
      return state.sendrequetes
    },
    getBaseUrl: state => {
      return state.baseUrl
    },
    getBaseUrlSrc: state => {
      return state.baseUrlSrc
    }
  },
  mutations: {

    /**************************************************
     // 01: MEDIA SELECT
     /**************************************************/

    loadMediaJson: (state) => {
      axios.get(state.baseUrlSrc + './json/media.json').then(response => {
        if (response.data && response.data.length > 0) {
          state.mediaOpsisValue = response.data[0]
        }
      })
    },

    updateMediaSelect: (state, payload) => {
      if (payload === 'Tous') {
        state.mediaSelectArray = ['Tous'];
        return;
      }

      const index = state.mediaSelectArray.indexOf(payload);

      if (index === -1) {
        // Ajouter l'élément sélectionné
        state.mediaSelectArray.push(payload);

        // Retirer 'Tous' si présent
        const tousIndex = state.mediaSelectArray.indexOf('Tous');
        if (tousIndex !== -1) {
          state.mediaSelectArray.splice(tousIndex, 1);
        }
      } else {
        // Retirer l'élément du tableau
        state.mediaSelectArray.splice(index, 1);

        // Si le tableau devient vide, ajouter 'Tous'
        if (state.mediaSelectArray.length === 0) {
          state.mediaSelectArray = ['Tous'];
        }
      }
    },

    /**************************************************
     // 02: CRITERE
     /*************************************************/

    loadCriteresList: (state, payload) => {
      // Transform Label URL friendly
      // const filename = payload.replace(/\s+/g, '_').toLowerCase().replace(/é|è|ê/g, 'e')
      /* TODO : test if custom request for loaded custom json */

      const filename = 'default'

      // LOAD JSON
      axios.get(state.baseUrlSrc + './json/critere_' + filename + '.json').then(response => {
        // Flat JSON in State var
        state.criteres = []
        response.data.map(critere => {
          // Accordeon 1st
          state.criteres.push(critere)
          critere.id = state.idCritereCounter++
          critere.level = 1
          critere.show = true
          critere.open = false
          critere.parent = null
          if (critere.innerFields && critere.innerFields.length > 0) {
            // Accordeon with Child
            critere.children = true

            critere.innerFields.map(souscritere => {
              state.criteres.push(souscritere)
              souscritere.id = state.idCritereCounter++
              souscritere.level = 2
              souscritere.parent = critere.id
              souscritere.show = false
              delete souscritere.chValues
              delete souscritere.type
              // delete souscritere.placeholder
            })

            delete critere.innerFields
          } else {
            critere.children = false
          }

          // Delete not used
          delete critere.chValues
          delete critere.type
        })
      })
    },

    toggleSousCritere: (state, payload) => {
      state.critereToggle = 'mixed' + payload.open + payload.id
      payload.open = !payload.open
      state.criteres.filter(function (item) {
        if (item.parent && (item.parent === payload.id)) {
          item.show = !item.show
        }
      })
    },

    openAllSousCritere: (state) => {
      state.critereToggle = true
      state.criteres.filter(function (item) {
        item.show = true
        if (item.children) {
          item.open = true
        }
      })
    },

    closeAllSousCritere: (state) => {
      state.critereToggle = false
      state.criteres.filter(function (item) {
        if (item.children) {
          item.open = false
        }
        if (item.parent) {
          item.show = false
        }
      })
    },

    /**************************************************
     // 03: REQUEST
     /*************************************************/

    toggleResetFrom (state, payload) {
      state.resetForm = payload
    },

    LoadRequestSaved: (state, payload) => {
      if (typeof document.getElementById('json_import').textContent !== 'undefined') {
        let brutLoadedReq = JSON.parse(document.getElementById('json_import').textContent)
        const valueToKeyMap = Object.fromEntries(Object.entries(state.mediaOpsisValue).map(([key, value]) => [value, key]))

        // Gestion du média (base_label)
        if (brutLoadedReq[0] && brutLoadedReq[0].chTypes === 'CFQ') {
          if (Array.isArray(brutLoadedReq[0].chValues)) {
            const filteredValues = brutLoadedReq[0].chValues.filter(value => value !== '')
            if (filteredValues.length > 0) {
              // Convert the values based on the mediaOpsisValue mapping
              state.mediaSelectArray = filteredValues.map(value => valueToKeyMap[value] || value)
            } else {
              state.mediaSelectArray = ['Tous']
            }
          } else {
            console.warn('chValues is not an array, converting to array')
            brutLoadedReq[0].chValues = [brutLoadedReq[0].chValues]
          }
          brutLoadedReq.shift() // Supprimer l'élément média car il sera reconstruit
        } else {
          console.warn('NO MEDIA TYPE IN SAVED')
        }

        // Réinitialiser state.requetes
        state.requetes = []
        // Ajouter d'abord les éléments du JSON importé
        state.requetes = [...brutLoadedReq]
      }
    },
    initRequeteJson: (state, payload) => {
      state.mediaSelectArray = ['Tous']
      state.lastMediaSelect = 'init'
      state.criteres = []
      state.sendrequetes = []
      state.requetes = []
      state.critereToggle = false
    },
    loadRequeteJson: (state, payload) => {
      function updateChValues (json1, json2) {
        json1.forEach(obj1 => {
          let matchingObj = json2.find(obj2 => obj2.chFields === obj1.chFields)
          if (matchingObj && obj1.chValues === '') {
            obj1.chValues = matchingObj.chValues
          }
        })
        return json1
      }

      // let filename = payload.replace(/\s+/g, '_').toLowerCase().replace(/é|è|ê/g, 'e')
      let filename = 'default'
      if ((state.mediaSelectArray.length === 1) && (state.mediaSelectArray[0] === 'Ecrits')) {
        filename = 'ecrits'
      }

      if (state.lastMediaSelect !== filename) {
        axios.get(state.baseUrlSrc + './json/requete_' + filename + '.json')
          .then(response => {
            let prevRequete = state.requetes // Variable sauvegardée avant modification
            let newRequete = JSON.parse(JSON.stringify(response.data)) // Nouvelle variable chargée via JSON
            state.requetes = updateChValues(newRequete, prevRequete)
            state.lastMediaSelect = filename
          })
      }
    },

    reset_requete (state) {
      state.requetes = [] // Réinitialise les requêtes
      state.sendrequetes = [] // Réinitialise les requêtes à envoyer
    },
    updateRequestOnDrop: (state, payload) => {
      function buildSimpleElem (item, isChildren = false) {
        let req = {}
        req.id = item.id
        req.chOps = item.chOps
        req.chLibs = item.chLibs
        req.chFields = item.chFields
        req.chValues = item.chValues
        req.chTypes = item.chTypes
        req.type = 'text'
        req.placeholder = (item.placeholder ? item.placeholder : '')
        req.index = item.index || false
        req.autocomplete = item.autocomplete || false
        req.children = []

        return req
      }

      function cleanSimpleElem (item) {
        item.id = state.idDispatchIDCounter++
        delete item.chValues
        delete item.type
        delete item.chFields
        delete item.chTypes
        delete item.chLibs
        delete item.autocomplete
        delete item.placeholder
        delete item.index

        return item
      }

      // # Recurcive Update parent/children
      function recurcivUpdateChildren (itemx) {
        if (itemx.children.length > 0 && itemx.hasOwnProperty('chFields')) {
          let newNode = buildSimpleElem(itemx, true)
          itemx = cleanSimpleElem(itemx)
          itemx.children.push(newNode)
        } else {
          itemx.children.filter(function (itemx2) {
            recurcivUpdateChildren(itemx2)
          })
        }
      }

      state.requetes.filter(item => {
        recurcivUpdateChildren(item)
      })
    },

    changeLineOperator: (state, payload) => {
      function switchOperator (payload) {
        switch (payload.chOps) {
          case 'AND':
            return 'OR'
          case 'OR':
            return 'NOT'
          default:
            return 'AND'
        }
      }

      // Recurcive Update Operator
      function recurcivOperatorChange (item) {
        if (item.id && (item.id === payload.id)) {
          item.chOps = switchOperator(payload)
        } else if (item.children.length > 0) {
          item.children.filter(function (itemx) {
            recurcivOperatorChange(itemx)
          })
        }
      }

      state.requetes.filter(function (item) {
        recurcivOperatorChange(item)
      })
    },

    clearForm: (state, payload) => {
      // console.log('clearForm')
      function updateChValues (obj) {
        if (obj.hasOwnProperty('chValues')) {
          obj.chValues = ''
        }

        if (obj.children && obj.children.length > 0) {
          obj.children.forEach(child => updateChValues(child))
        }
      }

      state.requetes.forEach(req => {
        updateChValues(req)
      })

      // Supprimer les éléments DOM avec la classe ti-tag
      const tags = document.querySelectorAll('.ti-tag')
      tags.forEach(tag => tag.remove())

      const datetags = document.querySelectorAll('.date-tag-elem');
      datetags.forEach(datetag => {
        // Retirer la classe 'active-tag'
        //datetag.classList.remove('active-tag');

        // Sélectionner l'input avec la classe 'flatpickr-input' à l'intérieur de datetag

        // Si l'input existe et est un flatpickr, utiliser l'API flatpickr pour vider la valeur
        if (datetag && datetag._flatpickr) {
          datetag._flatpickr.clear(); // Utilise l'API Flatpickr pour vider la valeur
        }
      });

    },

    cleanRequeteNode: (state, payload) => {
      // Fonction récursive pour nettoyer les enfants
      function recursiveClean (node) {
        // Si l'élément a des enfants, on les parcourt récursivement
        if (node.children && node.children.length > 0) {
          node.children = node.children
            .map(child => recursiveClean(child)) // Nettoie chaque enfant
            .filter(child => child !== false) // Filtre les éléments supprimés
        }

        // Si l'élément a encore des enfants après le nettoyage, on le garde
        if (node.children && node.children.length > 0) {
          return node
        }

        // Si l'élément a `chFields` ou d'autres propriétés utiles, on le garde
        if (node.hasOwnProperty('chFields')) {
          return node
        }

        // Si l'élément n'a ni `chFields` ni enfants valides, on le supprime
        return false
      }

      // Fonction récursive pour remonter les enfants si le parent n'a qu'un seul enfant
      function recursiveFlatten (node) {
        // Si le parent n'a qu'un seul enfant et n'a pas `chFields`, on remonte cet enfant
        if (!node.hasOwnProperty('chFields') && node.children && node.children.length === 1) {
          return recursiveFlatten(node.children[0]) // Remonte l'unique enfant
        }
        // Sinon, on garde le nœud tel quel
        return node
      }

      // Nettoie la racine (state.requetes)
      state.requetes = state.requetes
        .map(rootNode => recursiveClean(rootNode)) // Nettoie chaque élément racine
        .filter(rootNode => rootNode !== false) // Filtre les éléments supprimés
        .flatMap(rootNode => Array.isArray(rootNode) ? rootNode : [recursiveFlatten(rootNode)]) // Remonte les enfants si nécessaire
    },

    /**************************************************
     // 04: SEND QUERY
     /**************************************************/

    updateSendQuery: (state, payload) => {
      function buildElem (item, isChildren = false) {
        let req = {}
        // req.id = item.id
        req.chOps = item.chOps
        if (isChildren) {
          req.chFields = item.chFields
          // TODO : DATE ? item.chValues2 !== "" ?
          if (item.chValues2 && item.chValues2 !== '' && item.chTypes === 'D') {
            // console.log('DATE TO CONSTRUCT IN ' + item.chValues2)
            req.chValues2 = item.chValues2
          }
          // TODO : ELSE IF AUTO COMPLETE ?

          if (item.chValues !== '' && (item.chTypes === 'FT' || item.chTypes === 'FTE')) {
            // Tag object value
            let tempVal = []
            item.chValues.forEach(item => {
              if (item.operator !== '') {
                if (item.operator === 'ou') tempVal.push('OR')
                else if (item.operator === 'sf') tempVal.push('NOT')
                else tempVal.push('AND')
              }
              tempVal.push(item.tag)
            })
            req.chValues = tempVal
          } else {
            req.chValues = item.chValues
          }

          req.chTypes = item.chTypes
          req.type = item.type
        }
        return req
      }

      // Init Json (clear)
      state.sendrequetes = []

      const medialist = state.mediaSelectArray.map(media => state.mediaOpsisValue[media])

      // chTypes "CFQ"
      const buildMedia = {
        'chOps': 'AND', 'chValues': medialist, 'chFields': 'base_label', 'chTypes': 'CFQ', 'type': 'text', 'chLibs': 'Média'
      }

      // state.sendrequetes.push({'base_label': state.mediaOpsisValue[state.mediaSelect]})
      state.sendrequetes.push(buildMedia)

      let tempBuildReq = {}
      let cptloop1 = 0
      state.requetes.filter(item1 => {
        if (item1.children.length > 0) {
          tempBuildReq = buildElem(item1)
          let cptloop2 = 0
          item1.children.filter(item2 => {
            if (item2.children.length > 0) {
              tempBuildReq[cptloop2] = buildElem(item2)
              let cptloop3 = 0
              item2.children.filter(item3 => {
                tempBuildReq[cptloop2][cptloop3] = buildElem(item3, true)
                cptloop3++
              })
              // ---------END filter3
            } else {
              tempBuildReq[cptloop2] = buildElem(item2, true)
            }
            cptloop2++
          })
          // ---------END filter2
        } else {
          // NODE FIELD
          tempBuildReq = buildElem(item1, true)
        }
        state.sendrequetes.push(tempBuildReq)
        cptloop1++
      })
      // ---------END filter1

      // add sendrequetes JSON in Form Input
      document.getElementById('json_query').value = JSON.stringify(state.sendrequetes)
    },

    updateSendNativeQuery: (state, payload) => {
      state.sendrequetes = [...state.requetes]

      const medialist = state.mediaSelectArray.map(media => state.mediaOpsisValue[media])

      /* UPDATE MEDIA */
      const buildMedia = {
        'chOps': 'AND', 'chValues': medialist, 'chFields': 'base_label', 'chTypes': 'CFQ', 'type': 'text', 'chLibs': 'Média'
      }
      state.sendrequetes.unshift(buildMedia)
      // console.log(state.sendrequetes)
      document.getElementById('json_query').value = JSON.stringify(state.sendrequetes)
    }

  },

  actions: {
    emitInitCriteresList: ({ commit }, payload) => {
      const getImportValue = document.getElementById('json_import') ? document.getElementById('json_import').textContent : ''
      if (typeof getImportValue !== 'undefined' && getImportValue !== '') {
        commit('LoadRequestSaved', 'default')
      } else {
        commit('loadRequeteJson', 'default')
      }
      commit('loadMediaJson')
      commit('loadCriteresList', 'Tous')
    },
    emitUpdateMediaSelect: ({ commit }, payload) => {
      // console.log('emitUpdateMediaSelect')
      commit('updateMediaSelect', payload)
      commit('loadCriteresList', payload)
      commit('loadRequeteJson', payload)
      commit('updateSendNativeQuery', payload)
      // commit('LoadRequestSaved', 'Tous')
    },
    emitToggleSousCritere: ({ commit }, payload) => {
      commit('toggleSousCritere', payload)
    },
    emitOpenAllSousCritere: ({ commit }, payload) => {
      commit('openAllSousCritere')
    },
    emitCloseAllSousCritere: ({ commit }, payload) => {
      commit('closeAllSousCritere')
    },
    emitToggleAllSousCritere: ({ commit }, payload) => {
      if (payload) {
        commit('closeAllSousCritere')
      } else {
        commit('openAllSousCritere')
      }
    },
    emitChangeLineOperator: ({ commit }, payload) => {
      commit('changeLineOperator', payload)
      commit('updateSendNativeQuery', payload)
    },
    emitSaveFieldValue: ({ commit }, payload) => {
      commit('updateSendNativeQuery', payload)
    },
    emitCleanRequeteNode: ({ commit }, payload) => {
      commit('updateSendNativeQuery', payload)
      commit('updateRequestOnDrop', payload)
      commit('cleanRequeteNode', payload)
    },
    emitClearForm: ({ commit }, payload) => {
      // console.log('emit clearForm')
      commit('clearForm', payload)
      commit('updateSendNativeQuery', payload)
      commit('toggleResetFrom',true)
    },
    emitClearFormEnded: ({ commit }, payload) => {
      // console.log('emit emitClearFormEnded')
      commit('toggleResetFrom',false)
    },
    emitInitForm: ({ commit }, payload) => {
      // console.log('emitInitForm')
      commit('initRequeteJson', payload)
      commit('loadRequeteJson', payload)
      commit('loadCriteresList', payload)
      commit('updateSendNativeQuery', payload)
    }
  }
})
